
import {getProductByID, toAwning, toBlind } from '../shop-front-component/ProductCollection'

import GenericProductPage from './GenericProductPage'

export default function ProtectaPivotArmPage() {

  return (
      GenericProductPage(getProductByID(50),toAwning)
  )
}
